package net.zagart.ai.core.client.deepseek

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.header
import io.ktor.client.request.post
import io.ktor.client.request.preparePost
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsChannel
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess
import io.ktor.serialization.kotlinx.json.json
import io.ktor.utils.io.readUTF8Line
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.serialization.json.Json
import net.zagart.ai.core.client.AiChatRequest
import net.zagart.ai.core.client.AiChatResponse
import net.zagart.ai.core.client.AiClient
import net.zagart.ai.core.client.deepseek.exception.DeepseekException

class DeepseekClient(
    private val config: DeepseekConfig
) : AiClient, AutoCloseable {

    private val json = Json {
        ignoreUnknownKeys = true
        isLenient = true
    }

    private val httpClient = HttpClient {
        install(ContentNegotiation) {
            json(json)
        }
        install(HttpTimeout) {
            requestTimeoutMillis = config.timeoutMillis
        }
    }

    override suspend fun chat(request: AiChatRequest): AiChatResponse {
        val url = "${config.baseUrl}/chat/completions"
        println("[deepseek] POST $url")
        println("[deepseek] model=${request.model} messages=${request.messages.size} stream=${request.stream}")
        val response = httpClient.post(url) {
            header(HttpHeaders.ContentType, ContentType.Application.Json.toString())
            header(HttpHeaders.Authorization, "Bearer ${config.apiKey}")
            setBody(request.copy(stream = false))
        }
        println("[deepseek] response status=${response.status}")
        if (!response.status.isSuccess()) {
            val errorBody = response.bodyAsText()
            println("[deepseek] error body=$errorBody")
            throw DeepseekException("Deepseek API returned ${response.status}: $errorBody")
        }
        val body = response.body<AiChatResponse>()
        println("[deepseek] parsed: choices=${body.choices.size} usage=${body.usage}")
        return body
    }

    override fun chatStreaming(request: AiChatRequest): Flow<AiChatResponse> = flow {
        httpClient.preparePost("${config.baseUrl}/chat/completions") {
            header(HttpHeaders.ContentType, ContentType.Application.Json.toString())
            header(HttpHeaders.Authorization, "Bearer ${config.apiKey}")
            setBody(request.copy(stream = true))
        }.execute { response ->
            val channel = response.bodyAsChannel()
            while (!channel.isClosedForRead) {
                val line = channel.readUTF8Line() ?: continue
                if (line.startsWith("data: ")) {
                    val data = line.removePrefix("data: ")
                    if (data == "[DONE]") break
                    emit(json.decodeFromString<AiChatResponse>(data))
                }
            }
        }
    }

    override fun close() {
        httpClient.close()
    }
}
